import React, { useMemo } from 'react';
import { Plus, Info } from 'lucide-react';

interface RecommendedMenuProps {
  allMenuItems: any[]; 
  onAddToCart: (item: any) => void;
  onOpenDetail: (item: any) => void;
}

const RecommendedMenu: React.FC<RecommendedMenuProps> = ({ allMenuItems, onAddToCart, onOpenDetail }) => {
  // Ambil 6 item pertama
  const recommendedItems = useMemo(() => {
    if (!allMenuItems || !Array.isArray(allMenuItems)) return [];
    return allMenuItems.slice(0, 6);
  }, [allMenuItems]);

  // Jika data belum siap, jangan render (mencegah error .map)
  if (recommendedItems.length === 0) {
    return (
      <div className="py-20 text-center text-slate-400">
        Memuat menu favorit...
      </div>
    );
  }

  return (
    <section className="py-12 lg:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Header Manual untuk menghindari Circular Import dari App */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-slate-900 uppercase tracking-tight">
            Pilihan Favorit
          </h2>
          <p className="text-slate-500 mt-4 text-sm sm:text-base">
            Menu rekomendasi yang bisa kamu coba untuk dijadikan menu favoritmu!
          </p>
          <div className="h-1.5 w-20 bg-[#ee1d23] rounded-full mx-auto mt-6"></div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto">
          {recommendedItems.map((item, index) => (
            <article 
              key={item.id || index} 
              className="group rounded-[2.5rem] overflow-hidden transition-all flex flex-col h-full border bg-white border-slate-100 shadow-lg hover:shadow-2xl hover:-translate-y-2"
            >
              <div 
                onClick={() => onOpenDetail(item)} 
                className="relative h-60 sm:h-72 overflow-hidden cursor-pointer bg-slate-100" 
              >
                <img 
                  src={item.image} 
                  alt={item.name} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" 
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = "https://via.placeholder.com/400x300?text=Hisana+Fried+Chicken";
                  }}
                />
                <div className="absolute top-4 left-4 bg-[#ee1d23] text-white text-[10px] font-black uppercase tracking-widest px-4 py-2 rounded-full shadow-lg z-10">
                  BEST SELLER
                </div>
              </div>

              <div className="p-8 flex flex-col flex-grow text-center">
                <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 uppercase line-clamp-1">
                  {item.name}
                </h3>
                <p className="text-[#ee1d23] font-black text-xl mb-6">
                  Rp {item.priceNum?.toLocaleString('id-ID') || item.price}
                </p>
                <button 
                  onClick={() => onAddToCart(item)} 
                  className="mt-auto bg-[#ee1d23] text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl hover:bg-[#ce181e] transition-all flex items-center justify-center gap-3 active:scale-95"
                >
                  <Plus size={18} /> TAMBAH PESANAN
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecommendedMenu;